import { render } from "./PayoutMethodForm.vue?vue&type=template&id=7afa43ce&ts=true"
import script from "./PayoutMethodForm.vue?vue&type=script&lang=ts"
export * from "./PayoutMethodForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__